module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00008-fs8.8fdfdcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00008-fs8.png
// module id = 162
// module chunks = 0